import { RouteComponentProps } from 'react-router-dom';

export enum AutomationTabName {
    Automations = 'automations',
    Drafts = 'drafts',
}

export interface DateOptionsInterface {
    isBorderBottom?: boolean;
    value: number | string;
    label: string;
}

export enum TabNameEnum {
    Draft = 'drafts',
    Automations = '',
}
interface TabParams {
    tabName: string;
}

export type AutomationsListProps = RouteComponentProps<TabParams>;

export interface MobileFilterTabsProps {
    label: string;
    type: 'checkbox' | 'radio' | 'date';
    defaultValue?: string;
    defaultCheckboxValue?: string[];
    options: {
        value: string | number;
        label: string;
        count?: string | number;
    }[];
    startDate?: string;
    endDate?: string;
}
